// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"UserProfile_userProfile__1NAEb","button":"UserProfile_button__30VhI"};